export const column = [
  {
    label: "同步状态",
    prop: "synStatus",
  },
  {
    label: "账户ID",
    prop: "advertiserId",
  },
  {
    label: "广告账户名称",
    prop: "advertiserName",
  },
  {
    label: "公司主体",
    prop: "company",
  },
  {
    label: "授权状态",
    prop: "permissionStatus",
  },
  {
    label: "所属产品",
    prop: "productName",
  },
  {
    label: "所属部门",
    prop: "department",
  },
  {
    label: "来源",
    prop: "source",
  },
];
